import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import RealtimeContext from '../context/RealtimeContext';
const RealtimeProvider = ({ awareness, children, }) => {
    return (_jsx(RealtimeContext.Provider, { value: awareness, children: children }));
};
RealtimeProvider.displayName = 'RealtimeProvider';
export default observer(RealtimeProvider);
